import React from 'react';
import { isEqual } from 'lodash';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { firstResponseError } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import Dialog from '@/components/dialogs/Dialog';
import { fetchRoleActions, hideRoleActions, updateRoleActions } from '../actions';
import RoleActionsDropdown from './RoleActionsDropdown';
import fetch from '../hooks/fetch';

const EditRoleActionsDialog = ({
  category,
  code,
  fetchData,
  hide,
  readStatus,
  roleActions,
  save,
  theme,
  updateErrors,
  updateStatus,
}) => {
  const intl = useIntl();
  fetch.useFetchRoleActions(fetchData, category, code, readStatus, true);
  const initialRoleActions = React.useMemo(() => roleActions, []);
  const hasChanged = !isEqual(initialRoleActions, roleActions);

  return (
    <Dialog
      className="aridhia-edit-role-action-dialog tinywizard"
      error={firstResponseError(updateErrors)}
      icon="external"
      inProgress={updateStatus === states.PENDING}
      message="role.actions.dialog.description"
      minimumDataEntryMet={hasChanged}
      onClose={hide}
      onSave={() => save(code, category)}
      saveMessageId="actions.modify"
      size="small"
      theme={theme}
      title={intl.formatMessage({ id: 'role.actions.dialog.title' })}
    >
      <RoleActionsDropdown code={code} category={category} />
    </Dialog>
  );
};

const mapStateToProps = ({
  roles: {
    activeRoleActions: {
      code, category, roleActions, readStatus, updateStatus, updateErrors,
    },
  },
}) => ({
  code,
  category,
  roleActions,
  readStatus,
  updateStatus: updateStatus || states.NONE,
  updateErrors: updateErrors || [],
});

const mapDispatchToProps = {
  save: updateRoleActions,
  hide: hideRoleActions,
  fetchData: fetchRoleActions,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditRoleActionsDialog);
